import { IScrollState, IScrollActions } from './ScrollPositionContext.types';

export const initialState: IScrollState = {
  scrollPosition: 0,
  selectedRowKey: null,
  shouldRestorePosition: false,
  isNavigating: false,
};

const scrollPositionReducer = (state: IScrollState, action: IScrollActions): IScrollState => {
  switch (action.type) {
    case 'SET_SCROLL_POSITION':
      return {
        ...state,
        scrollPosition: action.payload,
      };
    case 'SET_SELECTED_ROW':
      return {
        ...state,
        selectedRowKey: action.payload,
      };
    case 'SET_SHOULD_RESTORE':
      return {
        ...state,
        shouldRestorePosition: action.payload,
      };
    case 'SET_NAVIGATING':
      return {
        ...state,
        isNavigating: action.payload,
      };
    case 'RESET_SCROLL_STATE':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default scrollPositionReducer;
